import React from 'react';
import PropTypes from 'prop-types';

export default function TerrainIcon({ color = '#ffffff', width = 20, height = 20 }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width={width} height={height} fill={color}>
      <path d="M256 131.2l-45.2 82.1H162.1L256 42.7l93.9 170.7H301.2L256 131.2zM93.5 426.7h325l-35.2-64H432l58.7 106.7H21.3L80 362.7h48.7l-35.2 64zM0 277.3C0 265.6 9.6 256 21.3 256H44.8c11.8 0 21.3 9.6 21.3 21.3s-9.6 21.3-21.3 21.3H21.3C9.6 298.7 0 289.1 0 277.3zm93.9 0c0-11.8 9.6-21.3 21.3-21.3h46.9c11.8 0 21.3 9.6 21.3 21.3s-9.6 21.3-21.3 21.3H115.2c-11.8 0-21.3-9.6-21.3-21.3zm117.3 0c0-11.8 9.6-21.3 21.3-21.3h46.9c11.8 0 21.3 9.6 21.3 21.3s-9.6 21.3-21.3 21.3H232.5c-11.8 0-21.3-9.6-21.3-21.3zm117.3 0c0-11.8 9.6-21.3 21.3-21.3h46.9c11.8 0 21.3 9.6 21.3 21.3s-9.6 21.3-21.3 21.3H349.9c-11.8 0-21.3-9.6-21.3-21.3zm117.3 0c0-11.8 9.6-21.3 21.3-21.3h23.5c11.8 0 21.3 9.6 21.3 21.3s-9.6 21.3-21.3 21.3H467.2c-11.8 0-21.3-9.6-21.3-21.3z" />
    </svg>
  );
}

TerrainIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};
